// extracted by mini-css-extract-plugin
export default {"speedometer":"style_speedometer__kDEIG","svg":"style_svg__jt0xp","rect":"style_rect__ePSDp"};